import RightBarGroup from './RightBarGroup'
import Select from './Select'
import { ChangeEventHandler, useMemo } from 'react'
import { getEnabledFeatures } from '@bm-js/atlascloud-shared'
import { useEditorActions, useEditorData } from '../utils/hooks'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const allFooterOptions = [
  {
    key: 'footer1',
    label: 'Atlas Cloud Basic',
  },
  {
    key: 'footer2',
    label: 'Atlas Cloud Enyoi',
  },
]

const FooterSelection = () => {
  const { tr } = useTr()
  const { patchConfig } = useEditorActions()
  const { workingConfig, backendResponse } = useEditorData()
  const { website } = backendResponse
  const handleSelect: ChangeEventHandler<HTMLSelectElement> = (e) => {
    patchConfig({ footerType: e.target.value })
  }

  const footerOptions = useMemo(() => {
    const enabledFeatures = getEnabledFeatures(website.features)
    return allFooterOptions.filter((option) => {
      return !!enabledFeatures.find(
        (feature) => feature.key === `${option.key}`
      )
    })
  }, [website.features])

  const shouldRender = useMemo(() => {
    return footerOptions.length > 1
  }, [footerOptions.length])

  if (!shouldRender) return null

  return (
    <RightBarGroup title='Footer'>
      <Select value={workingConfig.footerType} onChange={handleSelect}>
        <option disabled value=''>
          {tr(TrKey.editorLeftSelectFooterPlaceholder)}
        </option>
        {footerOptions.map((option) => (
          <option key={option.key} value={option.key}>
            {option.label}
          </option>
        ))}
      </Select>
    </RightBarGroup>
  )
}

export default FooterSelection
